import {combineReducers} from 'redux';
import contacts from './contacts';
import filters from './filters';
import tags from './tags';

export default combineReducers({ contacts, filters, tags });